import styled, { css } from 'styled-components';

import Card from 'shared/components/Card/Card';
import { CardDescriptionBold } from '../../../../shared/components/Card/Card.styles';

export const SystemDetailsCardsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 14px;

  > div {
    display: flex;
    flex-direction: column;
    flex-basis: 100%;
    margin: 0;
    max-width: unset;
    flex: 1;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.small}) {
    flex-direction: row;
    gap: 24px;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.medium}) {
    flex-direction: column;
  }
`;

export const CardBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  ${CardDescriptionBold} {
    color: ${({ theme }) => theme.colors.textPrimarySecondary1100};
  }
`;

export const SystemDetailsWrapper = styled.div`
  ${({ theme }) => css`
    border-radius: 24px;
    padding: 32px 20px;
    background: ${theme.colors.backgroundSecondaryGrey05};
    box-shadow: ${theme.elevations.extraSunken};
    height: fit-content;
  `}
  h2 {
    margin-bottom: 16px;
  }
`;

export const AutoPayCard = styled(Card)<{ $isAlreadyEnrolled?: boolean }>`
  ${({ $isAlreadyEnrolled }) => `
    pointer-events: ${$isAlreadyEnrolled ? 'none' : 'auto'};
  `}
`;
